export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ayer"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chat"])}
}